const translate = {
  portugues: {
    title: 'minha conta',
    subTitle: 'Informe seus dados de acesso abaixo.',
    placeHolderEmail: 'Informe seu usuário',
    placeHolderPassword: 'Informe sua senha',
    buttonLabel: 'Entrar',
    labelInformation:
      'Minha Conta é uma área destinada ao assinante do Bella da Semana. Aqui você pode:',
    listActivity: [
      'Conferir o histórico de pagamentos da sua assinatura',
      'Colocar sua assinatura do Bella da Semana em dia',
      'Imprimir a 2a via do boleto bancário',
      'Atualizar seus  dados cadastrais (e-mail e senha)'
    ],
    imgDefault: {
      name: 'Nome da Modelo',
      src: 'https://api.belladasemana.com.br/storage/imagens/minhaconta-bg-model.jpg'
    },
    imgBannerRodape: {
      name: 'Nome Banner Rodape',
      src: 'https://api.belladasemana.com.br/storage/banners/1539015349.jpg'
    },
    hello: 'Olá',
    sweetDo: 'escolha o que deseja fazer',
    navBar: ['Renovar assinatura', 'Meus Créditos', 'Cancelar assinatura', /*'Alterar forma de pagamento', 'Alterar plano',*/ 'Histórico de assinaturas', 'Alterar dados cadastrais'],
    historyTitle: 'Confira abaixo o seu histórico',
    historySubtitle: 'Aqui você pode conferir todos seus pagamentos efetuados.',
    userSubtitle: 'Aqui você pode conferir todos os dados da sua conta. ',
    placeholderNickname: 'Nickname',
    placeholderEmail: 'Seu e-mail',
    labelNewsletter: 'Receber newsletter:',
    labelPromotions: 'Receber promoções:',
    yes: 'Sim',
    no: 'Não',
    placeholderPassword: 'Nova senha',
    placeholderRepitePassoword: 'Redigite sua senha',
    buttonLabelSave: 'Salvar',
    titleCancel: 'Não quer mais assinar o Bella?',
    subtitleCancel: 'Se você tem certeza que quer cancelar sua assinatura, confirme abaixo:',
    infoCancel1: 'O cancelamento passa a vigorar ao fim deste ciclo de cobrança:',
    labelOptionCancel: 'Selecione o motivo do cancelamento de sua assinatura:',
    buttonLabelCancel: 'Solicitar cancelamento', 
    inputCancelMessage: 'Outros (especifique abaixo)',
    infoCancel2: 'Volte quando quiser. Se você reiniciar sua assinatura dentro de 2 meses, seus perfis, seus favoritos, suas preferências e os detalhes da sua conta estarão aguardando por você.',
    listMotivosCancel: ['Preço da assinatura', 'Qualidade dos ensaios', 'Pouca nudez', 'Frequência de atualizações', 'Conteúdo diferente do que esperava', 'Estou satisfeito com o conteúdo aberto', 'Dificuldade no acesso', 'Outros (especifique abaixo)'],
    listMotivosCancelName: ['price', 'quality', 'little_nudity', 'updates_frequency', 'expected_different_content', 'satisfied_opened_content', 'difficult_access', 'none_above'],    
    forgotPwd1: 'Se você esqueceu sua senha, ',
    forgotPwd2: 'clique aqui',
    orderStatus: 'Status da conta',
    orderPlanName : 'Plano',
    orderMethodName : 'Forma de pagamento',
    orderStart : 'Ínicio',
    orderFinish : 'Fim',
    alertMessageOrderActived: 'Você já possui uma assinatura ativa! Só é possivel renovar após o vencimento no dia: ',
    placeholderMessage: 'Mensagem',
    setReasonCancel: 'Informe algum motivo!',
    setMessageReasonCancel: 'Informe Outro(s) motivos na Mensagem!',
    cancelAttention: 'Atenção!',
    notCancelledYet: 'Sua assinatura <b>AINDA NÃO FOI CANCELADA!</b><br><br>Uma mensagem de confirmação será enviada para seu email.<br> Lembre-se de verificar a caixa de Spam ou Lixeira.<br><br> <b>PARA CONFIRMAR SEU PEDIDO DE CANCELAMENTO,<br> VOCÊ DEVE CLICAR NO LINK ENVIADO PARA SEU E-MAIL.</b>',
    notSubscribe: 'Nenhuma assinatura ativa.',
    msgWaiting: 'Aguarde o processamento...',
    msgSendMail: 'Informe seu email abaixo',
    btnSendMail: 'Enviar',
    btnClose: 'Fechar',
    pwdReset: 'Redefinição de Senha',
    formResetEmail: 'E-mail',
    formResetPwd: 'Nova senha',
    formResetPwdConfirm: 'Confirme sua senha',
    formResetButton: 'Salvar',
    checkFailedText1: 'Link expirado!',
    checkFailedText2: 'Por favor, repita o procedimento de recuperação de senha.',
    checkFailedText3: 'Ir para página de redefinição de senha',
    msgSuccess: 'Ir para página de login'        ,
    footer1ModalPlan: 'jÁ É SÓCIO?',
    footer2ModalPlan: 'FAÇA LOGIN PARA COMPRAR CRÉDITOS COM DESCONTO',
  },
  ingles: {
    title: 'my account',
    subTitle: 'Enter your access details below.',
    placeHolderEmail: 'Enter your username',
    placeHolderPassword: 'Enter your password',
    buttonLabel: 'Enter',
    labelInformation:
      'My Account is an area dedicated to Bella da Semana subscribers. Here you can:',
    listActivity: [
      'Check your subscription payment history',
      'Catch up on your Bella Club subscription',
      'Print the 2nd copy of the bank slip',
      'Update your registration details (email and password)'
    ],
    imgDefault: {
      name: 'Model Name',
      src: 'https://api.belladasemana.com.br/storage/imagens/minhaconta-bg-model.jpg'
    },
    imgBannerRodape: {
      name: 'Banner Footer Name',
      src: 'https://api.belladasemana.com.br/storage/banners/1539015349.jpg'
    },
    hello: 'Hello',
    sweetDo: 'choose what you want to do',
    navBar: ['Renew subscription', 'My Credits', 'Cancel subscription', /*'Change payment method', 'Change plan',*/ 'Subscription history', 'Change registration data'],
    historyTitle: 'Check your history below',
    historySubtitle: 'Here you can check all your payments made.',
    userSubtitle: 'Here you can check all your account data. ',
    placeholderNickname: 'Nickname',
    placeholderEmail: 'Your email',
    labelNewsletter: 'Receive newsletter:',
    labelPromotions: 'Receive promotions:',
    yes: 'Yes',
    no: 'No',
    placeholderPassword: 'New password',
    placeholderRepitePassword: 'Retype your password',
    buttonLabelSave: 'Save',
    titleCancel: "Don't you want to subscribe to Bella anymore?",
    subtitleCancel: 'If you are sure you want to cancel your subscription, confirm below:',
    infoCancel1: 'The cancellation takes effect at the end of this billing cycle:',
    labelOptionCancel: 'Select the reason for canceling your subscription:',
    buttonLabelCancel: 'Request cancellation',
    inputCancelMessage: 'Other (specify below)',
    infoCancel2: 'Come back whenever you want. If you restart your subscription within 2 months, your profiles, bookmarks, preferences and account details will be waiting for you.',
    listMotivosCancel: ['Subscription price', 'Quality of rehearsals', 'Little nudity', 'Frequency of updates', 'Content different from what I expected', 'I am satisfied with the open content', 'Difficulty accessing', 'Others (specify below)'],
    listMotivosCancelName: ['price', 'quality', 'little_nudity', 'updates_frequency', 'expected_different_content', 'satisfied_opened_content', 'difficult_access', 'none_above'],        
    forgotPwd1: 'If you forgot your password, ',
    forgotPwd2: 'click here',
    orderStatus: 'Account status',
    orderPlanName : 'Plan',
    orderMethodName : 'Payment method',
    orderStart : 'Start',
    orderFinish: 'End',
    alertMessageOrderActived: 'You already have an active subscription! It is only possible to renew after expiration on the day: ',
    placeholderMessage: 'Message',
    setReasonCancel: 'Please provide a reason!',
    setMessageReasonCancel: 'Please provide other reasons in the Message!',
    cancelAttention: 'Attention!',
    notCancelledYet: 'Your membership <b>STILL HAS NOT BEEN CANCELED!</b><br><br> A confirmation e-mail will be sent to your email.<br> Please verify your Spam or Bin.<br><br> <b>IN ORDER TO CONFIRM YOUR REQUEST,<br> YOU MUST CLICK ON THE LINK THAT WAS SENT TO YOU BY E-MAIL.</b>',
    notSubscribe: 'No active subscriptions.',
    msgWaiting: 'Wait for processing...',
    msgSendMail: 'Enter your email below',
    btnSendMail: 'Send',
    btnClose: 'Close',
    pwdReset: 'Password Reset',    
    formResetEmail: 'E-mail',
    formResetPwd: 'New Password',
    formResetPwdConfirm: 'Confirm your password',
    formResetButton: 'Save',
    checkFailedText1: 'Link expired!',
    checkFailedText2: 'Please repeat the password recovery procedure.',
    checkFailedText3: 'Go to password reset page',
    msgSuccess: 'Go to login page',
    footer1ModalPlan: 'jÁ É SÓCIO?',
    footer2ModalPlan: ' FAÇA LOGIN PARA COMPRAR CRÉDITOS COM DESCONTO',    
   }
}

export default translate
